// Liczniki akcji planu + etykieta "co jeszcze sie wykona" (dialog NS).
import type { PlanRow } from "@/services/cloudflare/transferTypes";

export const planCounts = (rows: PlanRow[]) => ({
  zone: rows.filter((r) => r.actions[0].decision === "run").length,
  ns: rows.filter((r) => r.actions[1].decision === "run").length,
  a: rows.filter((r) => r.actions[2].decision === "run").length,
});

export const otherActionsLabel = (c: { zone: number; a: number }) =>
  [c.zone ? `${c.zone} ${c.zone === 1 ? "zona" : "zon"}` : "", c.a ? `${c.a} ${c.a === 1 ? "rekord A" : "rekordów A"}` : ""]
    .filter(Boolean)
    .join(", ") || "nic poza NS";
